<div class="carousel" data-cy="carousel" [ngClass]="{'carousel-margin' : $safeNavigationMigration(state.carousel?.length) > 0}">
  <div class="carousel-arrows-wrapper">
    @if (displayNavigation()) {
      <button class="carousel-arrow left"
        data-cy="carousel-arrow-left"
        (click)="carouselArrowDirection(carouselDirectionLeft)">
        <span class="iwp-icon-gen_arrow_left"></span>
      </button>
    }

    @for (data of state.carousel; track data; let index = $index) {
      <div class="carousel-box-wrapper" [ngClass]="getShowCarouselClass(data.status)">
        <div class="carousel-box" data-cy="carousel-box" [ngClass]="carouselSeverityType">
          <span class="carousel-box-icon" data-cy="carousel-box-icon"
          [ngClass]="{'iwp-icon-gen_info_info info': carouselSeverityType === carouselSeverityTypeInfo}"></span>
          <div class="carousel-box-info">
            <div class="carousel-box-info-header">
              <div class="carousel-box-info-title" [attr.data-cy]="'carousel-box-info-title-' + index">{{data.title}}</div>
              <button class="carousel-box-close"
                [attr.data-cy]="'carousel-box-close-' + index"
                [ngClass]="{'info': carouselSeverityType === carouselSeverityTypeInfo}"
                (click)="closeCarouselBox(index)">
                <span class="iwp-icon-gen_close_l"></span>
              </button>
            </div>
            <div class="carousel-box-info-description-wrapper">
              <div class="carousel-box-info-description"
              [attr.data-cy]="'carousel-box-info-description-' + index">{{data.description}}</div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (displayNavigation()) {
      <button class="carousel-arrow right"
        data-cy="carousel-arrow-right"
        (click)="carouselArrowDirection(carouselDirectionRight)">
        <span class="iwp-icon-gen_arrow_right"></span>
      </button>
    }
  </div>

  @if (displayNavigation()) {
    <div class="carousel-dot" data-cy="carousel-dot">
      @for (carouselDots of state.carousel; track carouselDots; let index = $index) {
        <div class="carousel-box-dot"
          (click)="carouselDotsClick(index)"
          [ngClass]="getDotClass(carouselDots.status)"
        [attr.data-cy]="'carousel-dot-' + index"></div>
      }
    </div>
  }

</div>
